"use client";

import { useEffect } from "react";

import { trackGalleryPageViewed } from "@/lib/posthog-client";

export function GalleryPageTracker({ itemCount }: { itemCount: number }) {
  useEffect(() => {
    trackGalleryPageViewed({ itemCount });
  }, [itemCount]);

  return null;
}
